import dispatch from '../../main';
import { setDataFilters } from 'redux-modules/country-profiles';
function getCountryProfilesParams(state) {
  return {
    sector: state.params.sector,
    years: state.location.query.years
        ? decodeURIComponent(state.location.query.years).split(',').filter((el) => el && !isNaN(el))
        : []
  };
}

function hasNewCountryProfileParams(prevState, nextState) {
  return (
      prevState.location.search !== nextState.location.search ||
      prevState.params.displayBy !== nextState.params.displayBy ||
      prevState.params.sector !== nextState.params.sector
  );
}

export function initCountryProfilesParams(actualState, replace, done) {
  dispatch(setDataFilters(getCountryProfilesParams(actualState)));
  done();
}

export function updateCountryProfilesParams(prevState, nextState, replace, done) {
  if (hasNewCountryProfileParams(prevState, nextState)) {
    dispatch(setDataFilters(getCountryProfilesParams(nextState)));
  }
  done();
}



// WEBPACK FOOTER //
// ./app/routes/actions/country-profiles.js